import { CLIENT_STATE_KEYS } from '@thoughtspot/client-state-util';
import { getTextWidth } from '@thoughtspot/custom-style-service';
import _ from 'lodash';
import { configureColors } from '../core/chart-color-utils';
import { getChartProperty, getVisibleSeriesIds, } from '../core/chart-model-utils';
import { configOptions } from '../core/chart-type-specification-service';
import { getSerie } from '../data/data-util';
import { LEGEND_BASE_FONT_SIZE, LEGEND_FONT_FAMILY, } from '../theme/chart-theme-service';
import { LegendPositionOptions } from '../types';
export const VERTICAL_LEGEND_WIDTH_RATIO = 0.25;
export const LEGEND_ITEM_WIDTH = 45;
export const LEGEND_SCROLL_FACTOR = 1.2;
export const legendPositionDropdownOptions = {
    RightLegend: 'charts.chartEditor.RIGHT_LEGEND',
    LeftLegend: 'charts.chartEditor.LEFT_LEGEND',
    TopLegend: 'charts.chartEditor.TOP_LEGEND',
    BottomLegend: 'charts.chartEditor.BOTTOM_LEGEND',
};
export const getClientLegendPosition = vizModel => {
    return getChartProperty(vizModel, CLIENT_STATE_KEYS.legendPosition);
};
export const isLegendEnabled = vizModel => {
    return getChartProperty(vizModel, CLIENT_STATE_KEYS.showLegend);
};
export const isTopPositionedLegend = vizModel => {
    return (getClientLegendPosition(vizModel) === LegendPositionOptions.TopLegend);
};
export const isLeftPositionedLegend = vizModel => {
    return (getClientLegendPosition(vizModel) === LegendPositionOptions.LeftLegend);
};
export const getVerticalPositionedLegend = () => {
    return [
        LegendPositionOptions.LeftLegend,
        LegendPositionOptions.RightLegend,
    ];
};
export const getHorizontalPositionedLegend = () => {
    return [
        LegendPositionOptions.TopLegend,
        LegendPositionOptions.BottomLegend,
    ];
};
export const getColorOptions = (chartModel, dataModel, updateClientStateProperty, getTranslatedText) => {
    const chartConfigOption = configOptions(chartModel.config.chartType, chartModel);
    const colorOptions = configureColors(chartModel, chartConfigOption, dataModel, getTranslatedText, updateClientStateProperty);
    return colorOptions;
};
export const getLegendItems = (colorOptions, chartModel, dataModel, visibleSeriesIds) => {
    return colorOptions.map(colorOption => {
        const label = colorOption.caption;
        const color = colorOption.selectedColor;
        const serieId = getSerie(dataModel, colorOption.caption).blinkSeriesId.toLowerCase();
        return {
            ...colorOption,
            label,
            id: serieId,
            color,
            enabled: _.indexOf(visibleSeriesIds, serieId) >= 0,
        };
    });
};
export const getLegendWidth = (chartContainerWidth, fontSize, dataModel) => {
    let legendWidth = '';
    const legendFont = fontSize;
    let legendItemWidth = LEGEND_ITEM_WIDTH;
    legendItemWidth *= parseInt(legendFont, 10) / LEGEND_BASE_FONT_SIZE;
    const maxWidth = parseInt(chartContainerWidth, 10) * VERTICAL_LEGEND_WIDTH_RATIO;
    let textWidth = 0;
    dataModel.longestSerieNames.forEach(serieName => {
        const currentWidth = getTextWidth(serieName, legendFont + LEGEND_FONT_FAMILY);
        textWidth = Math.max(textWidth, currentWidth);
    });
    textWidth += legendItemWidth;
    legendWidth = `${textWidth > maxWidth ? maxWidth : textWidth}px`;
    return legendWidth;
};
export const getVisibleSeriesBlinkIds = (chartModel, allSeriesMap) => {
    var _a;
    const visibleSeriesNames = ((_a = getVisibleSeriesIds(chartModel)) === null || _a === void 0 ? void 0 : _a.map(item => item.toLowerCase())) || [];
    return allSeriesMap
        .filter(serieObj => {
        return (_.indexOf(visibleSeriesNames, serieObj.blinkSeriesId) >= 0 ||
            _.indexOf(visibleSeriesNames, serieObj.seriesName) >= 0);
    })
        .map(item => item.blinkSeriesId);
};
//# sourceMappingURL=chart-legend-utils.js.map